import React from 'react';
import { Box } from 'theme-ui';

export function HideAfter({ target, displayType = 'block', children }) {
  const targets = {
    mobile: [displayType, 'none'],
    tablet: [displayType, null, 'none'],
  };

  return (
    <Box sx={{ display: targets[target] || targets.desktop }}>{children}</Box>
  );
}
